class LabelContainer {
    element = document.querySelector('#subtitles-label') as HTMLParagraphElement

    show = () => {
        this.element.classList.remove('hidden')
    }

    hide = () => {
        this.element.classList.add('hidden')
    }

    setText = (label = '') => {
        this.element.innerText = label
    }

    clear = () => {
        this.setText()
    }
}

export default new LabelContainer()
